export const TR_SCENARIO_CACHE_KEYS = {
  config: (projectId?: string) => ["trConfig", projectId] as const,
  detail: (projectId?: string, configId?: number) => ["trConfig", projectId, configId],
  list: (projectId?: string) => ["trScenarios", projectId] as const,
};
